import { render, staticRenderFns } from "./listItem4more.vue?vue&type=template&id=46bb2cbf&scoped=true&"
import script from "./listItem4more.vue?vue&type=script&lang=ts&"
export * from "./listItem4more.vue?vue&type=script&lang=ts&"
import style0 from "./listItem4more.vue?vue&type=style&index=0&id=46bb2cbf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb2cbf",
  null
  
)

export default component.exports